import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';
import { handleLoginSuccess, handleLogout } from '../utils/androidBridge';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isLoading: false,
      
      login: async (credentials) => {
        set({ isLoading: true });
        try {
          const response = await api.post('/auth/login', credentials);
          const { user, token } = response.data;
          
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          
          // Android 앱에 로그인 정보 전달
          handleLoginSuccess(token, user);
          
          set({ user, token, isLoading: false });
          return { success: true };
        } catch (error) {
          set({ isLoading: false });
          const errorData = error.response?.data;
          return { 
            success: false, 
            error: errorData?.message || errorData?.error || 'Login failed',
            errorType: errorData?.error,
            deactivatedAt: errorData?.deactivated_at
          };
        }
      },
      
      customerAccess: async (projectId, password) => {
        set({ isLoading: true });
        try {
          const response = await api.get(`/auth/customer/${projectId}/${password}`);
          const { user, token, project, allProjects } = response.data;
          
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          
          // VIP 고객의 모든 프로젝트 저장
          if (allProjects) {
            localStorage.setItem('vipProjects', JSON.stringify(allProjects));
          }
          
          set({ user, token, isLoading: false });
          return { success: true, project, allProjects, user };
        } catch (error) {
          set({ isLoading: false });
          return { 
            success: false, 
            error: error.response?.data?.error || 'Access failed' 
          };
        }
      },
      
      logout: async () => {
        try {
          await api.post('/auth/logout');
        } catch (error) {
          console.error('Logout error:', error);
        }
        
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('vipProjects'); // VIP 프로젝트 정보 삭제
        
        // Android 앱에 로그아웃 알림
        handleLogout();
        
        set({ user: null, token: null });
      },
      
      getCurrentUser: async () => {
        try {
          const response = await api.get('/auth/me');
          const { user, vipInfo } = response.data;
          set({ user: { ...user, vipInfo } });
          return user;
        } catch (error) {
          console.error('Get current user error:', error);
          return null;
        }
      },
      
      initialize: () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        
        if (token && user) {
          set({ 
            token, 
            user: JSON.parse(user) 
          });
        }
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        user: state.user, 
        token: state.token 
      }),
    }
  )
);

export default useAuthStore;